<template>
<modal-layout modal-name="send-to-kakao-talk-modal" :width="getSize()">
    <h1 slot="header">문자 문의</h1>
    <div slot="contents" class="contents">
        <ul>
            <li>
                <label>휴대폰 번호 <span>(입력해주신 번호로 답변드립니다.)</span></label>
                <input type="text" placeholder="-빼고 숫자만 입력" v-model="sendData.user_phone_no" />
            </li>
            <li>
                <label>문의 내용</label>
                <textarea placeholder="내용을 입력해 주십시오." v-model="sendData.question"></textarea>
            </li>
        </ul>
        <div class="policy-check-view flex">
            <div>
                <input type="checkbox" id="policyCheckBox" v-model="isCheckedPrivacyAgree" /><label for="policyCheckBox">(필수) 개인정보 이용 동의</label>
            </div>
            <div>
                <span @click="openPrivacy">[약관 보기]</span>
            </div>
        </div>
    </div>
    <div slot="footer" class="send-footer">
        <button @click="sendToKakaoTalk">전송하기</button>
    </div>
</modal-layout>
</template>

<script>
import ModalLayout from "../Layout/ModalLayout"
import Utils from "../../utils/Utils"

export default {
    name: "SendToKakaoTalkModal",
    components: {
        ModalLayout
    },
    props: {
        kosiwonId: {
            type: String || Number,
            default: ""
        }
    },
    data() {
        return {
            sendData: {
                user_phone_no: "",
                question: ""
            },
            isCheckedPrivacyAgree: false
        }
    },
    methods: {
        getSize() {
            return Utils.isSmallScreen() ? "90%" : 375
        },
        async sendToKakaoTalk() {
            const phoneNoRegExp = /^\d{3}-?\d{3,4}-?\d{4}$/

            if (!this.kosiwonId) {
                alert("올바르지 못한 경로입니다.");
                return;
            } else if (!this.sendData.user_phone_no) {
                alert("전화번호는 필수로 입력해 주시기 바랍니다.")
                return
            } else if (!phoneNoRegExp.test(this.sendData.user_phone_no)) {
                alert("유효한 전화번호를 입력해 주시기 바랍니다.")
                return
            } else if (!this.isCheckedPrivacyAgree) {
                alert("개인정보 처리방침에 동의 해주셔야 서비스 이용이 가능합니다.")
                return
            }

            try {
                const result = await this.axios.post(`/kosiwons/${this.kosiwonId}/sendKakaoTalkConsultation`, {
                    ...this.sendData
                })

                if (result.status === 200) {
                    alert("고시원 원장님께 카카오톡으로 내용을 전달하였습니다.\n원장님이 내용확인 후 유선으로 응대해주실 예정입니다.")
                }
                this.clearData()
                this.$modal.hide("send-to-kakao-talk-modal")
            } catch (error) {
                alert("발송 중 오류가 발생하였습니다.\n잠시 후 다시 시도해 주시기 바랍니다.")
            }
        },

        clearData() {
            this.sendData.user_phone_no = ""
            this.sendData.question = ""
            this.isCheckedPrivacyAgree = false
        },
        openPrivacy() {
            const routeData = this.$router.resolve({
                name: "privacy"
            })
            window.open(routeData.href, "_blank")
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/palette";

.header {
    font-size: 1.6rem;
}

.contents {
    li {
        &:first-child {
            padding-bottom: 2.3rem;
        }

        /*padding: 0 4rem;*/
        label {
            display: block;
            font-weight: bold;
            font-size: 1.4rem;
            padding: 1.25rem 0;

            span {
                font-size: 1.2rem;
            }
        }

        input {
            min-height: 4rem;
            border-bottom: 2px solid @black-two;
        }

        input,
        textarea {
            box-sizing: border-box;
            width: 100%;
            display: block;
        }

        textarea {
            border: 1px solid #d6d6d6;
            padding: 1rem;
            min-height: 27rem;
        }
    }

    .policy-check-view {
        justify-content: space-between;
        padding-top: 2rem;

        /*font-size: 2rem;*/
        div {
            &:first-child {
                input[type=checkbox] {
                    margin-right: 1rem;
                }
            }

            &:last-child {
                span {
                    color: @windows-blue-two;
                    font-weight: bold;
                }
            }
        }
    }
}

.send-footer {

    /*padding: 1.5rem 4rem 0;*/
    button {
        height: 50px;
        background-color: @windows-blue;
        width: 100%;
        color: white;
    }
}
</style>
